module.exports = __webpack_public_path__ + "media/35.a459e963.ogg";